import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from "@angular/core";
import { Router } from "@angular/router";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";

// store
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";

// models
import { AppState } from "../../models/app-state.interface";
import { FlightAPIRequest } from "../../models/flight-request.interface";
import { LoadingStatusInitState } from "../../../shared/models/loading-status.interface";

// services
import { EventsService } from "../../services/events.service";
import { CopyService } from "../../../shared/services/app-copy.service";
import { FlightDetailsService } from "../../../shared/services/flight-details.service";
import { AppLoaderService } from "../../../shared/services/app-loader.service";
import { AppStateService } from "../../../shared/services/app-state.service";

declare var exponea: any;
declare var ga: any;

@Component({
  selector: "app-upsell",
  templateUrl: "./upsell.component.html",
  styleUrls: ["./upsell.component.scss"],
})
export class UpsellComponent implements OnInit {
  private _userLanguageSubscription: Subscription;
  private _loadingSubscription: Subscription;

  public bookingInit = false;
  public firstLoad = true;
  private _isDomestic = false;
  private _destinationCountry: string = null;
  private _bookingCarrier: string;

  public bookingProduct;
  public isMultiLeg = false;
  public arrivalCityName = "";
  public lastLegAirlineCode = "";
  public lastLegAirlineNumber = "";
  public lastLegAirportCode = "";
  public bookingType: string;
  public flightStatusDetails;
  public fromPrice = "";
  public showUpsellABC = false;
  public showUpsellCCD = false;
  public upsellCheapestPrice: any;
  public selectedCurrencySymbol = "";
  public userSelectedServicetype: string = "";

  public selectedLanguage = "";
  public languageCode = "";

  public flightDirection;
  public airlineCode;

  public copyLoaded: Boolean = false;
  public appCopy;

  constructor(
    private _appStateService: AppStateService,
    private _appStore: Store<AppState>,
    private _flightDetailsService: FlightDetailsService,
    private _eventsService: EventsService,
    private _router: Router,
    private _copyService: CopyService,
    private _appLoaderService: AppLoaderService,

    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    // increase panel
    // this._eventsService.goToPanel("prev");
    // this._appStore.dispatch({ type: "CURRENT_BOOKING_LOADED", payload: false });

    this._loadingSubscription = this._appStore
      .select("loadedStatusReducer")
      .subscribe((res: LoadingStatusInitState) => {
        this.copyLoaded = res.copyLoaded;
        if (res.currentBookingLoaded && this.firstLoad) {
          this.bookingInit = res.currentBookingLoaded;

          if (isPlatformBrowser(this.platformId)) {
            if (res.copyLoaded) {
              // temp solution for browser back navigation
              // in case if it is already d2d redirect user to last screen
              const state = this.getState(this._appStore);
              const isD2dService = state.bookingReducer.bookingDetails.isD2dService;
              const currentBookingType = state.bookingReducer.bookingDetails.bookingProduct;
              if (isD2dService) {
                const url = currentBookingType === "abc" ? "delivery-time" : "collection-time"
                const upsellBookingType = currentBookingType !== "abc" ? "abc" : "ccd"
                this._eventsService.goToBookingSwitcher(upsellBookingType, url, null, 'falseD2D');
                // this._router.navigate([url], {replaceUrl: true});
              }

              this.upsellHandler(false);
              this.firstLoad = false;
              this.setDataSubscriptions();
              this.getCopy();
            }

            this._userLanguageSubscription = this._appStore
              .select("copyReducer")
              .subscribe((res: any) => {
                this.selectedLanguage = res.language;
                this.languageCode = res.languageCode;
              });
          }
        }
      });
  }

  setBookingState() {
    const _state = this.getState(this._appStore);
    const _currentBookingProduct =
      _state.bookingReducer.bookingDetails.bookingProduct;
    this.bookingType = _state.bookingReducer.bookingDetails.bookingType;
    // set app state
    // pass in bookingProduct if needed, booking type if needed
    // service to determine if new/refreshed booking and store values
    this._appStateService.setAppState(this.bookingType, _currentBookingProduct);
  }

  setDataSubscriptions() {
    this.setCurrentStoreVars();

    if (isPlatformBrowser(this.platformId)) {
      ga(
        "set",
        "page",
        "/upsell/" + this.bookingProduct === "abc" ? "ccd" : "abc"
      );
    }
  }

  cancel() {
    // navigate to payment
    const getState = this.getState(this._appStore);
    this.bookingProduct = getState.bookingReducer.bookingDetails.bookingProduct;

    this._eventsService.goToPanel("prev");

    exponea.track("oldfunnel_upsell", {
      upsell_product: this.bookingProduct === "abc" ? "ccd" : "abc",
      selection: false,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
    });
  }

  goBack() {
    let path = this.bookingProduct === "abc" ? "collection-time" : "delivery-time";
    if (this.getState(this._appStore).hubDropReducer.selectedCollectionType === 'atPostOffice') {
      path = 'collection-post-office';
    }
    this._eventsService.goToPanelByPath(path);
  }

  setCurrentStoreVars() {
    const currentAppState = this.getState(this._appStore);
    // booking store vars
    const bookingState = currentAppState.bookingReducer;
    this.bookingProduct = bookingState.bookingDetails.bookingProduct;
    this.airlineCode = bookingState.bookingDetails.carrier.airlineCode;
    this.flightDirection =
      bookingState.bookingDetails.journeyLegDetails[0].journeyDirection;
    this._bookingCarrier = bookingState.bookingDetails.carrier.airlineCode;
    this._isDomestic =
      currentAppState.flightReducer.flightDetails.flightProducts.isDomesticABC;
    this.userSelectedServicetype = currentAppState.d2dReducer.userSelectedServicetype;
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      "OTHER",
      "upsell",
      this.flightDirection === 1 ? ["CCDArrivalsUpsell"] : ["ABCArrivalsUpsell"]
    );

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

    console.log(this.appCopy);
  }

  upsellHandler(d2dConverted) {
    const getState = this.getState(this._appStore);
    const bookingState = JSON.parse(JSON.stringify(getState));
    const flightData = getState.flightReducer.flightDetails;
    const bookingDetails = bookingState.bookingReducer.bookingDetails;
    const currentBookingType = bookingDetails.bookingProduct;
    const isD2dService = bookingDetails.isD2dService;
    const isABC = bookingState.d2dReducer.flightDetails.flightProducts.abc;
    const isCCD = bookingState.d2dReducer.flightDetails.flightProducts.ccd;
    this.flightStatusDetails = flightData.flightResponse.flightStatusDetails;
    this.isMultiLeg = this.flightStatusDetails.length > 1 ? true : false;
    const selectedTimeslotGroup = getState.timeslotReducer.selectedGroup;
    this.arrivalCityName =
      this.flightStatusDetails[
        this.flightStatusDetails.length - 1
      ].arrivalAirport.airportCityName;
    this.lastLegAirportCode =
      this.flightStatusDetails[
        this.flightStatusDetails.length - 1
      ].arrivalAirport.airportCode;
    this.lastLegAirlineNumber =
      this.flightStatusDetails[
        this.flightStatusDetails.length - 1
      ].flightNumber;
    this.lastLegAirlineCode =
      this.flightStatusDetails[this.flightStatusDetails.length - 1].airlineCode;
    if (this.bookingType !== "amend") {
      this.fromPrice = selectedTimeslotGroup.fromPrice;
      this.selectedCurrencySymbol = selectedTimeslotGroup.currencySymbol;
    }

    if (d2dConverted) {
      exponea.track("oldfunnel_upsell", {
        upsell_product: currentBookingType === "abc" ? "ccd" : "abc",
        selection: true,
        entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      });

      this._appStore.dispatch({ type: "UPDATE_D2D_SERVICE", payload: true });
      this._appLoaderService.showLoader("", true);

      this.d2dBookingHandler();
    }

    if (
      (!isD2dService && !d2dConverted && isABC && isCCD) ||
      (!isD2dService &&
        getState.d2dReducer.hasSession &&
        isABC &&
        isCCD &&
        !d2dConverted)
    ) {
      if (currentBookingType === "abc") {
        this.showUpsellCCD = true;
        this.upsellCheapestPrice = getState.d2dReducer.inboundPrice;
      } else {
        this.showUpsellABC = true;
        this.upsellCheapestPrice = getState.d2dReducer.outboundPrice;
      }
    }
  }

  d2dBookingHandler() {
    const getState = this.getState(this._appStore);
    const bookingState = JSON.parse(JSON.stringify(getState));
    const d2dBookingReducer = bookingState.d2dReducer;
    const flightReducer = bookingState.flightReducer;
    const bookingReducer = bookingState.bookingReducer;
    const currentBookingReducer = bookingState.currentBookingReducer;
    const priceReducer = bookingState.priceReducer;
    const timeslotReducer = bookingState.timeslotReducer;
    const flightFinderReducer = bookingState.flightFinderReducer;
    const hubDropReducer = bookingState.hubDropReducer;

    const bookingDetails = bookingState.bookingReducer.bookingDetails;
    const isD2dService = bookingDetails.isD2dService;
    const currentBookingType = bookingDetails.bookingProduct;

    // get flight products from d2d and update in flight reducer
    const productAvailability =
      flightReducer.flightDetails.flightResponse.productAvailability;
    const flightProductsAvailable =
      d2dBookingReducer.flightDetails.flightProducts;
    const flightResponse = JSON.parse(
      JSON.stringify(flightReducer.flightDetails.flightResponse)
    );

    let flightAvailability = {
      abcAvailable: !productAvailability.abcAvailable,
      ccdAvailable: !productAvailability.ccdAvailable,
      sdsAvailable: flightProductsAvailable.sds,
      isDomesticABC: flightProductsAvailable.isDomesticABC,
      journeyDirection: 2,
    };

    if (productAvailability.ccdAvailable) {
      flightAvailability = {
        abcAvailable: !productAvailability.abcAvailable,
        ccdAvailable: !productAvailability.ccdAvailable,
        sdsAvailable: flightProductsAvailable.sds,
        isDomesticABC: flightProductsAvailable.isDomesticABC,
        journeyDirection: 1,
      };
    }

    let request: FlightAPIRequest;
    // call getFlightStatus api for 2nd booking type
    const nextFlightDirection = productAvailability.abcAvailable ? 2 : 1;
    flightResponse.productAvailability = flightAvailability;

    // call getFlightStatsData()
    const flight = flightResponse;
    const isMultiLegFlight = flightResponse.totalNumberOfLegs > 1;
    flight.flightDirection = nextFlightDirection;
    request = {
      firstLeg: {
        flightNumber:
          flight.flightStatusDetails[0].airlineCode +
          flight.flightStatusDetails[0].flightNumber,
        flightDirection: nextFlightDirection,
        departureDate:
          nextFlightDirection == 1
            ? flight.flightStatusDetails[0].departureDateTimeDetails
                .scheduledDateTimeLocal
            : flight.flightStatusDetails[0].arrivalDateTimeDetails
                .scheduledDateTimeLocal,
        isPrimary: true,
      },
    };

    if (isMultiLegFlight || flight.productAvailability === null) {
      request.firstLeg.isPrimary = flight.flightStatusDetails[0].isPrimaryLeg;

      request.lastLeg = {
        flightNumber:
          flight.flightStatusDetails[flight.flightStatusDetails.length - 1]
            .airlineCode +
          flight.flightStatusDetails[flight.flightStatusDetails.length - 1]
            .flightNumber,
        flightDirection: nextFlightDirection,
        departureDate:
          nextFlightDirection == 1
            ? flight.flightStatusDetails[flight.flightStatusDetails.length - 1]
                .departureDateTimeDetails.scheduledDateTimeLocal
            : flight.flightStatusDetails[flight.flightStatusDetails.length - 1]
                .arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary:
          flight.flightStatusDetails[flight.flightStatusDetails.length - 1]
            .isPrimaryLeg,
      };
    }

    if (
      isMultiLegFlight &&
      flightAvailability.ccdAvailable &&
      !flightAvailability.abcAvailable
    ) {
      request.firstLeg.isPrimary = false;
      request.lastLeg.isPrimary = true;
      request.lastLeg.flightDirection = 2;
    }

    if (isMultiLegFlight || getState.flightFinderReducer.requestLegs > 1) {
      this._appStore.dispatch({ type: "UPDATE_API_SEARCH", payload: true });
    }

    // in case of FlightSession used
    if (getState.d2dReducer.hasSession) {
      request = JSON.parse(
        JSON.stringify(getState.d2dReducer.sessionFlightStatusRequest)
      );
      if (currentBookingType === "abc") {
        request.firstLeg.flightDirection = 2;
        request.firstLeg.isPrimary = false;
        if (isMultiLegFlight || getState.flightFinderReducer.requestLegs > 1) {
          request.lastLeg.flightDirection = 2;
          request.lastLeg.isPrimary = true;
        }
      } else {
        request.firstLeg.flightDirection = 1;
        request.firstLeg.isPrimary = true;
        if (isMultiLegFlight || getState.flightFinderReducer.requestLegs > 1) {
          request.lastLeg.flightDirection = 1;
          request.lastLeg.isPrimary = false;
        }
      }
      this._appStore.dispatch({
        type: "SAVE_BOOKING_DETAILS",
        payload: {
          bookingType:
            currentBookingType === "abc" ? "outboundBooking" : "inboundBooking",
          flightReducer,
          bookingReducer,
          currentBookingReducer,
          priceReducer,
          timeslotReducer,
          flightFinderReducer,
          hubDropReducer,
          isCompleted: true,
        },
      });
      // reset reducers
      this._appStore.dispatch({ type: "RESET_PRICE" });
      this._appStore.dispatch({ type: "RESET_TIMESLOT_STATE" });
      this._appStore.dispatch({ type: "RESET_BOOKING_OBJECT" });
      this._appStore.dispatch({ type: "RESET_HUBDROP_REDUCER" });
      this._appStore.dispatch({ type: "SELECTED_SERVICE_TYPE", payload: "d2d" });
      this._flightDetailsService.getFlightStatsData(
        flight,
        request,
        true,
        false,
        false,
        true,
        null
      );
      return;
    }

    const availableProductTypes = JSON.parse(
      JSON.stringify(d2dBookingReducer.flightDetails.flightProducts)
    );
    const _productAvailability = {
      abcAvailable: availableProductTypes.abc,
      ccdAvailable: availableProductTypes.ccd,
      sdsAvailable: availableProductTypes.sds,
      isDomesticABC: availableProductTypes.isDomesticABC,
    };

    this._appStore.dispatch({
      type: "SAVE_BOOKING_DETAILS",
      payload: {
        bookingType:
          currentBookingType === "abc" ? "outboundBooking" : "inboundBooking",
        flightReducer,
        bookingReducer,
        currentBookingReducer,
        priceReducer,
        timeslotReducer,
        flightFinderReducer,
        hubDropReducer,
        isCompleted: true,
      },
    });
    // reset reducers
    this._appStore.dispatch({ type: "RESET_PRICE" });
    this._appStore.dispatch({ type: "RESET_TIMESLOT_STATE" });
    this._appStore.dispatch({ type: "RESET_BOOKING_OBJECT" });
    this._appStore.dispatch({ type: "RESET_HUBDROP_REDUCER" });
    this._appStore.dispatch({ type: "SELECTED_SERVICE_TYPE", payload: "d2d" });
    this._flightDetailsService.getFlightStatsData(
      flight,
      request,
      false,
      false,
      false,
      true,
      _productAvailability
    );
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }

  ngOnDestroy() {
    this._loadingSubscription.unsubscribe();
    if (this._userLanguageSubscription) {
      this._userLanguageSubscription.unsubscribe();
    }
  }
}
